// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Switch_wrap__3a_yB","checkbox":"Switch_checkbox__3dXxp","slider":"Switch_slider__3K6p0","label":"Switch_label__3AxJs"};